import HeroSearchFormSmall from 'components/HeroSearchFormSmall/HeroSearchFormSmall';
import hero from 'images/hero.png';

export function Hero() {

    return (
        <div className='mb-8 md:mb-0 w-full'>
            <section className='w-full flex flex-col md:flex-row gap-6 md:gap-0 justify-between p-6 items-center'>
                <div className='flex flex-col justify-center gap-4'>
                    <h1 className='text-4xl md:text-6xl font-bold'>
                        Boas-vindas à ViroTrip!
                    </h1>
                    <p>
                        A sua assinatura de viagens que permite viajar com facilidade
                        e viver intensamente.
                    </p>
                </div>
                <img src={hero} alt="Hero" className='object-cover object-center ml-16' />
            </section>
            <div className='w-[90%] h-56 hidden md:block mx-auto'>
                <HeroSearchFormSmall />
            </div>
        </div>
    )
}
